import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoleModel, GraphiqueModels, GraphiqueModel, Graphique, DashboardModel, DashboardItem } from '../models';
import { CoreService, HttpService } from '../services';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {

  private item: DashboardItem;
  private width: number = 0;
  private height: number = 0;
  private gridItem: Subject<any> = new Subject<any[]>();
  private graphiques: GraphiqueModels;

  constructor(
    protected http: HttpService,
    protected indParam: CoreService
  ) { }

  ////////////////// communicate with collection and get the property og items when drag and drop /////////////
  sendItem(item: DashboardItem): void {
    this.item = item;
  }
  getItem(): DashboardItem {
    return this.item;
  }

  //////////////// communicate size to item componenet
  sendSize(item: any[]): any {
    this.gridItem.next(item);
  }

  getSize(): Observable<any> {
    return this.gridItem.asObservable();
  }
  ///////////////////////////////////////////

  getRolesAndContext(): Observable<{ roles: Array<{ id: string, Name_ROL: string }>, lanceurs: Array<{ id: string, Info_LAN: string }> }> {
    return this.http.getHttp(`${this.indParam.AppParams.apiUrl}api/Role/getData/ROLELANCEUR/0`).pipe(
      map((res: RoleModel) => {
        const roles: { id: string, Name_ROL: string }[] = new Array<{ id: string, Name_ROL: string }>();
        for (const role of res.Roles) {
          const r: { id: string, Name_ROL: string } = { id: role['Ident'], Name_ROL: role['Name_ROL'] };
          roles.push(r);
        }
        const lanceurs: { id: string, Info_LAN: string }[] = new Array<{ id: string, Info_LAN: string }>();
        for (const lanceur of res.Lanceur) {
          const l: { id: string, Info_LAN: string } = { id: lanceur['Ident'], Info_LAN: lanceur['Info_LAN'] };
          lanceurs.push(l);
        }
        return { roles, lanceurs };
      })
    );
  }

  getCollection(idContext: string, idRole: string): Observable<any> {
    return this.http.getHttp<any>(`${this.indParam.AppParams.apiUrl}api/dashboard/getData/INITADMIN/${idContext}|${idRole}`);
  }

  saveDashboard(idContext: string, idRole: string, items: Array<DashboardItem>): Observable<DashboardModel> {
    const dashboardModel: DashboardModel = new DashboardModel();
    dashboardModel.IdRole = idRole;
    dashboardModel.IdContext = idContext;
    dashboardModel.Mode = 'additem';
    dashboardModel.DashboardItemList = items;
    return this.http.postHttp<DashboardModel>(`${this.indParam.AppParams.apiUrl}api/dashboard/postData/`, dashboardModel);
  }

  getWidth(): number {
    return this.width;
  }

  getHeight(): number {
    return this.height;
  }

  public getGraphique(xml: string): Observable<GraphiqueModels> {
    this.graphiques = new GraphiqueModels();
    const mode: string = `dashboardData|${xml}`;
    //return this.http.getHttp<GraphiqueModels>(`${this.indParam.ConfigFile.apiUrl}api/graphiqueItem/getData/${mode}/0`);
    return this.http.getHttp<GraphiqueModels>(`${this.indParam.AppParams.apiUrl}api/graphiqueItem/getData/${mode}/0`);
  }


  public getDataGraphique(id: string): any {

    const graph: GraphiqueModel = new GraphiqueModel();
    for (let i: number = 0; i < this.graphiques.Graphiques.length; i++) {
      if (this.graphiques.Graphiques[i].Key === id) {
        graph.Key = this.graphiques.Graphiques[i].Key;
        graph.ChartLabel = this.graphiques.Graphiques[i].ChartLabel;
        graph.ChartType = this.graphiques.Graphiques[i].ChartType;
        graph.Title = this.graphiques.Graphiques[i].Title;
        graph.ChartData = this.graphiques.Graphiques[i].ChartData;
        break;
      }
    }
    return new Graphique(graph.Key, graph.ChartType, graph.Title, graph.ChartLabel, JSON.parse(graph.ChartData));
  }
}
